(function () {
    'use strict';

    angular
        .module('oddQuestionnaireTemplateModule')
        .controller('oddQuestionnaireTemplateFullController', Controller);

    Controller.$inject = ['$scope', '$timeout', '$state', 'notificationService', 'govNotificationDelay', 'oddQuestionnaireTemplateService', 'modalService'];

    function Controller($scope, $timeout, $state, notificationService, govNotificationDelay, oddQuestionnaireTemplateService, modalService) {
     
        $scope.ctrlCtxt = {};
        $scope.ctrlCtxt.ReadOnlyState = ($scope.boxModel.IsInCampaign === true || $scope.boxModel.IsShared === true);

        $scope.$watch('boxModel', function (model) {
            $scope.ctrlCtxt.ReadOnlyState = ($scope.boxModel.IsInCampaign === true || $scope.boxModel.IsShared === true);
        });

        // Create Or Update
        $scope.createOrUpdate = function () {
            if ($scope.form.$invalid) {
                $scope.ctrlCtxt.showSubmitError = true;
                $scope.ctrlCtxt.isFormInvalidMsgShow = true;

                $timeout(function () {
                    $scope.ctrlCtxt.isFormInvalidMsgShow = false;
                }, govNotificationDelay);

                return;
            }

            $scope.ctrlCtxt.isFormInvalidMsgShow = false;
            $scope.ctrlCtxt.showSubmitError = false;
            $scope.ctrlCtxt.isLoading = true;

            // Create Questionnaire
            if (!$scope.boxModel.ODDQuestionnaireID) {
                return oddQuestionnaireTemplateService
                        .createQuestionnaire($scope.boxModel.ODDBusinessUnitID, $scope.boxModel)
                        .then(function (createdQuestionnaire) {
                            $scope.form.$setPristine();
                            notificationService.notify('The Questionnaire was created');

                            $scope.boxContext.questionnaireTemplates.push(createdQuestionnaire);
                            $state.go('odd.questionnaireTemplatesEdit.questionnaire', {
                                ODDQuestionnaireID: createdQuestionnaire.ODDQuestionnaireID
                            });
                        })
                        .finally(function () {
                            $scope.ctrlCtxt.isLoading = false;
                        });
            }

            // Update Questionnaire
            return oddQuestionnaireTemplateService
                    .updateQuestionnaire($scope.boxModel.ODDBusinessUnitID, $scope.boxModel)
                    .then(function(updatedQuestionnaire) {
                        $scope.boxModel = updatedQuestionnaire;

                        var idx = _.findIndex($scope.boxContext.questionnaireTemplates, {ODDQuestionnaireID: updatedQuestionnaire.ODDQuestionnaireID});
                        $scope.boxContext.questionnaireTemplates[idx] = updatedQuestionnaire;

                        notificationService.notify('Your changes have been saved');
                        $scope.form.$setPristine();
                    })
                    .finally(function () {
                        $scope.ctrlCtxt.isLoading = false;
                    });
        };

        // Duplicate Questionnaire
        $scope.duplicateQuestionnaire = function () {

            if (_.isUndefined($scope.boxModel.ODDQuestionnaireID)) return;

            modalService.displayFormModal(

                // Title
                'Please provide a title for the duplicated questionnaire',

                // Content Config
                [{ key: 'title', label: 'Title', type: modalService.types.TEXT, required: true }],

                // Success Callback
                function (values) {
                    return oddQuestionnaireTemplateService
                             .duplicateQuestionnaire($scope.boxModel.ODDBusinessUnitID, $scope.boxModel.ODDQuestionnaireID, values.title)
                             .then(function (duplicatedQuestionnaire) {
                                 $scope.form.$setPristine();
                                 $state.go('odd.questionnaireTemplatesEdit.questionnaire', {
                                     ODDQuestionnaireID: duplicatedQuestionnaire.ODDQuestionnaireID
                                 });
                             });
                }
            );
        };

        // Delete
        $scope.deleteQuestionnaire = function () {
            $scope.ctrlCtxt.isLoading = true;

            return oddQuestionnaireTemplateService.deleteQuestionnaire(
                          $scope.boxModel.ODDBusinessUnitID,
                          $scope.boxModel.ODDQuestionnaireID)
                      .then(function () {
                          notificationService.notify('Questionnaire has been deleted');

                          $state.go('odd.questionnaireTemplatesEdit', {}, { reload: true });
                      })
                      .finally(function () {
                          $scope.ctrlCtxt.isLoading = false;
                      });
        };

        // Share Questionnaire
        $scope.shareQuestionnaire = function () {
            $scope.ctrlCtxt.isLoading = true;

            return oddQuestionnaireTemplateService.shareQuestionnaire(
                                                      $scope.boxModel.ODDBusinessUnitID,
                                                      $scope.boxModel.ODDQuestionnaireID)
                      .then(function (data) {
                          notificationService.notify('Questionnaire shared');
                          $scope.boxModel = data;
                      })
                      .finally(function () {
                          $scope.ctrlCtxt.isLoading = false;
                          $state.reload();
                      });
        }

        // Unshare Questionnaire
        $scope.unshareQuestionnaire = function () {
            $scope.ctrlCtxt.isLoading = true;

            return oddQuestionnaireTemplateService.unshareQuestionnaire(
                                                      $scope.boxModel.ODDBusinessUnitID,
                                                      $scope.boxModel.ODDQuestionnaireID)
                      .then(function (data) {
                          notificationService.notify('Questionnaire unshared');
                          $scope.boxModel = data;
                      })
                      .finally(function () {
                          $scope.ctrlCtxt.isLoading = false;
                          $state.reload();
                      });
        }

        // Discard Changes
        $scope.discardChanges = function () {
            $state.reload();
        };

        // Cancel
        $scope.cancel = function () {
            $state.go($state.$current.parent.name, { reload: true });
        };
    }

})();